import store from './store';
import login from './auth';

export default {
    store,
    login,
};
